<template>
  <div class="content">
    <!--nav-->
    <div class="top pc">
      <div class="commen">
        <div class="topa fl"></div>
        <div class="topb fr">
          <div class="topb_a fl">
            <a @click="ToUserConsole" style="cursor: pointer;">
              <img src="@/view/images/y2.png" />
              <p>控制台</p>
              <div class="clearfix"></div>
            </a>
          </div>
          <!--登录前-->
          <div class="topb_b fl" v-if="logintype === 0">
            <a :href="`${VUE_APP_LOGIN}login/:PORTAL/`" target="_blank">登录</a>
            <span>|</span>
            <a :href="`${VUE_APP_LOGIN}register`" target="_blank">注册 </a>
          </div>
          <!--登录后-->

          <div class="topb_c fl" v-if="logintype === 1">
            <!-- <a href="#">消息<span>2</span></a> -->
            <div class="topb_ca fl">
              <p @mouseenter="loginshow(1)" @mouseleave="loginshow(0)">
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="userInfo.userName"
                  placement="right-end"
                ></el-tooltip
                >{{ userInfo.userName }}
              </p>
              <div
                class="topb_cax"
                v-show="loginshowtype == 1"
                @mouseenter="loginshow(1)"
                @mouseleave="loginshow(0)"
              >
                <!-- <a :href="`${VUE_APP_USERCONSOLE}PersonalCenter/PersonalDatum`"
                  >用户中心</a
                > -->
                <!-- <a :href="`${VUE_APP_USERCONSOLE}Course/MyCourse/My-Course`">我的课程</a>
                <a :href="`${VUE_APP_USERCONSOLE}Course/Indent`"
                  >我的订单</a
                > -->
                <a @click="exit" style="cursor:pointer">退出登录</a>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>

    <header-nav></header-nav>
    <!-- <div class="logo pc">
      <div class="commen">
        <div class="logoa fl">
          <a href="javascript:void(0);">
            <img src="@/view/images/LOGO-1.png" />
          </a>
        </div>
        <div class="nav fl">
          <div
            class="nava fl"
            :class="navaa == 0 ? 'navaa' : ''"
            @click="navaabtn(0)"
          >
            <p>
              <a href="javascript:void(0);">
                <router-link to="/">首页</router-link>
              </a>
            </p>
          </div>
          <div
            class="nava fl"
            :class="navaa == 1 ? 'navaa' : ''"
            @click="navaabtn(1)"
            @mouseenter="showchide(1)"
            @mouseleave="showchide(0)"
          >
            <p>
              <a href="javascript:void(0);">
                <router-link to="/solution?navaa=1" @click="navaabtn(1)"
                  >解决方案</router-link
                >
              </a>
            </p>
            <div
              class="navb navc"
              :class="navaa == 1 ? 'showtabdiv' : ''"
            >
              <div class="navca fl" style="width: 100%;">
                <h5>
                  <a href="#">
                    <router-link to="/solution?navaa=1" @click="navaabtn(1)"
                      >印刷管家服务解决方案</router-link
                    >
                  </a>
                </h5>
                <h5>
                  <a href="#">
                    <router-link to="/solution1?navaa=1" @click="navaabtn(1)"
                      >印刷数字化工厂解决方案</router-link
                    >
                  </a>
                </h5>
              </div>
              <div class="navca fr">
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
          <div
            class="nava fl"
            :class="navaa == 3 ? 'navaa' : ''"
            @click="navaabtn(3)"
            @mouseenter="showchide(2)"
            @mouseleave="showchide(0)"
          >
            <p>
              <a href="javascript:void(0);">
                <router-link to="/academic?navaa=3" @click="navaabtn(3)"
                  >学习园地</router-link
                >
              </a>
            </p>
          </div>
          <div
            class="nava fl"
            :class="navaa == 4 ? 'navaa' : ''"
            @click="navaabtn(4)"
            @mouseenter="showchide(3)"
            @mouseleave="showchide(0)"
          >
            <p>
              <a href="javascript:void(0);">
                <router-link to="/information?navaa=4">新闻资讯</router-link>
              </a>
            </p>
          </div>
          <div
            class="nava fl"
            :class="navaa == 5 ? 'navaa' : ''"
            @click="navaabtn(5)"
            @mouseenter="showchide(4)"
            @mouseleave="showchide(0)"
          >
            <p>
              <a href="javascript:void(0);">
                <router-link to="/about?navaa=5">关于我们</router-link>
              </a>
            </p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="tel fr"><img src="@/view/images/y3.png" /></div>
        <div class="clearfix"></div>
      </div>
    </div> -->
    <!--手机导航-->
    <div class="sjdhgd">
      <div class="sjdh mob">
        <div class="sjdha">
          <div class="sjdha_t1 fl">
            <a href="javascript:void(0);">
              <router-link to="/"
                ><img src="@/view/images/logo.png"
              /></router-link>
            </a>
          </div>
          <div class="topb fl">
            <!-- <div class="topb_a fl">
              <a href="javascript:void(0);">
                <img src="@/view/images/y29.png">
                <p>控制台</p>
                <div class="clearfix"></div>
              </a>
            </div> -->
            <!--登录前-->
            <!-- <div class="topb_b fl" v-if="logintype == 0">
              <a href="javascript:void(0)" @click="login">登录</a>
              <span>|</span>
              <a href="javascript:void(0)" @click="register">注册 </a>
            </div> -->
            <!--登录后-->
            <!-- <div class="topb_c fl">
              <a href="#">消息<span>2</span></a>
              <div class="topb_ca fl">
                <p>印工社</p> -->
            <!-- <div class="topb_cax">
                  <a href="#">个人中心</a>
                  <a href="#">我的课程</a>
                  <a href="#">我的订单</a>
                  <a href="#">退出登录</a>
                </div> -->
            <!-- </div>
            </div> -->
          </div>
          <div class="sjdha_t2" @click="hkbtn">
            <img src="@/view/images/k52.png" />
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="huakuai" :class="huakuai == 1 ? 'huakuaileft' : ''">
          <div class="sjdhb fr">
            <div class="guanbi" @click="guanbi">
              <img src="@/view/images/k53.png" />
              <div class="clearfix"></div>
            </div>
            <div
              class="sjdhb_a "
              :class="navaa == 0 ? 'sjdhb_ah1' : ''"
              @click="navaabtn(0)"
            >
              <h6>
                <a href="javascript:void(0);">
                  <router-link to="/index?navaa=0">首页</router-link>
                </a>
              </h6>
            </div>
            <div
              class="sjdhb_a"
              :class="navaa == 1 ? 'sjdhb_ah1' : ''"
              @click="navaabtn(1)"
            >
              <h6>
                <a href="javascript:void(0);">
                  <router-link to="/solution?navaa=1">解决方案</router-link>
                </a>
              </h6>
              <div class="sjdhb_aa">
                <p class="sjdhb_p" @click="navaabtn(1)">
                  <a href="javascript:void(0);">
                    <router-link to="/solution2?navaa=1"
                    >蜂享优印解决方案</router-link
                    >
                  </a>
                </p>
                <p class="sjdhb_p" @click="navaabtn(1)">
                  <a href="javascript:void(0);">
                    <router-link to="/solution?navaa=1"
                      >印刷管家服务解决方案</router-link
                    >
                  </a>
                </p>
                <p class="sjdhb_p" @click="navaabtn(1)">
                  <a href="javascript:void(0);">
                    <router-link to="/solution1?navaa=1"
                      >印刷数字化工厂解决方案</router-link
                    >
                  </a>
                </p>
              </div>
            </div>
            <!-- <div class="sjdhb_a" :class="navaa == 2 ? 'sjdhb_ah1':''" @click="navaabtn(2)">
              <h6><a href="javascript:void(0);">
                <router-link to="/usercase?navaa=2">客户案例</router-link>
              </a></h6>
            </div> -->
            <div
              class="sjdhb_a"
              :class="navaa == 3 ? 'sjdhb_ah1' : ''"
              @click="navaabtn(3)"
            >
              <h6>
                <a href="javascript:void(0);">
                  <router-link to="/academic?navaa=3">学术园地</router-link>
                </a>
              </h6>
              <!-- <div class="sjdhb_aa">
                <p class="sjdhb_p"><a href="javascript:void(0);">印刷管理培训</a></p>
                <p class="sjdhb_p"><a href="javascript:void(0);">印刷技术培训</a></p>
                <p class="sjdhb_p"><a href="javascript:void(0);">印刷技术培训</a></p>
                <p class="sjdhb_p"><a href="javascript:void(0);">学员天地</a></p>
              </div> -->
            </div>
            <div
              class="sjdhb_a"
              :class="navaa == 4 ? 'sjdhb_ah1' : ''"
              @click="navaabtn(4)"
            >
              <h6>
                <a href="javascript:void(0);">
                  <router-link to="/information?navaa=4">新闻资讯</router-link>
                </a>
              </h6>
              <!-- <div class="sjdhb_aa" @click="navaabtn(4)">
                <p class="sjdhb_p"><a href="javascript:void(0);">
                  <router-link to="/information?navaa=4">企业动态</router-link>
                </a></p>
                <p class="sjdhb_p"><a href="javascript:void(0);">行业资讯</a></p>
                <p class="sjdhb_p"><a href="javascript:void(0);">深度阅读</a></p>
              </div> -->
            </div>
            <div
              class="sjdhb_a"
              :class="navaa == 5 ? 'sjdhb_ah1' : ''"
              @click="navaabtn(5)"
            >
              <h6>
                <a href="javascript:void(0);">
                  <router-link to="/about?navaa=4">关于我们</router-link>
                </a>
              </h6>
              <!-- <div class="sjdhb_aa">
                <p class="sjdhb_p"><a href="gy.html">公司介绍</a></p>
                <p class="sjdhb_p"><a href="gy.html#gy1">企业文化</a></p>
                <p class="sjdhb_p"><a href="gy.html#gy2">专家团队</a></p>
                <p class="sjdhb_p"><a href="gy.html#gy3">战略布局</a></p>
                <p class="sjdhb_p"><a href="gy.html#gy4">联系我们</a></p>
              </div> -->
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
    <router-view />
    <!--footer-->
    <div class="yj">
      <div class="commen">
        <div class="yja fl">
          <span></span>
          <h5 class="pc">印工社<br />印刷工业互联网平台</h5>
          <h5 class="mob">印工社打造<br />印刷智能工厂</h5>
          <h6>咨询热线<span>400-999-2025</span></h6>
          <p class="pc">青岛市高新区祥源路831号青岛报业传媒数字印刷产业园综合楼3楼</p>
        </div>
        <div class="yjb fl pc">
          <div class="yjba fl">
            <h6>印刷管家服务解决方案</h6>
            <p>
              色彩管理体系构建
            </p>
            <p>色彩管理体系优化</p>
            <p>
              质量评测方法建立
            </p>
            <p>
              印刷管家服务APP
            </p>
            <p>
              人才赋能计划
            </p>
            <p>
              印刷设备校正
            </p>
          </div>
          <!-- <div class="yjba fl yjbb">
            <h6><a href="#">印刷数字化工厂解决方案</a></h6>
            <p class="fl">
              <a href="#"><span></span>MES</a>
              <a href="#"><span></span>WMS</a>
              <a href="#"><span></span>IIOT</a>
              <a href="#"><span></span>ERP</a>
              <a href="#"><span></span>APS</a>
              <a href="#"><span></span>PLM</a>
            </p>
            <p class="fl">
              <a href="#"><span></span>BI</a>
              <a href="#"><span></span>QMS</a>
              <a href="#"><span></span>CPS</a>
              <a href="#"><span></span>CRM</a>
              <a href="#"><span></span>CMS</a>
              <a href="#"><span></span>AIDS</a>
            </p>
            <div class="clearfix"></div>
          </div>
          <div class="yjba fl">
            <h6><a href="#">学术园地</a></h6>
            <p>
              <a href="#">印刷管理培训</a>
              <a href="#">印刷技术培训</a>
              <a href="#">管理咨询</a>
              <a href="#">学员天地</a>
            </p>
          </div> -->
        </div>
        <div class="yjc fr">
          <div class="yjca fl">
            <img src="@/view/images/ewm.png" />
            <p>APP二维码</p>
          </div>
          <div class="yjca fl">
            <img src="@/view/images/ewm1.png" />
            <p>公众号二维码</p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="clearfix"></div>
        <div class="yjd">
          <p>
            Copyright© 2019-{{ DataYears }} 印工社（青岛）数字科技有限公司 All
            Rights Reserved<span>|</span
            ><a
              href="https://beian.miit.gov.cn"
              target="_banck"
              style="corsor:pointer"
            >
              鲁ICP备20000134号-3</a
            ><span></span><a href="https://beian.mps.gov.cn/#/query/webSearch?code=37021402002207\" target="_banck">鲁公网安备 37021402002207号</a><span class="span1">|</span
            >网站建设：<a href="#">印工社</a>
          </p>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <!-- <div class="yl pc">
      <p>
        友情链接：<a href="#">友情链接</a><a href="#">友情链接</a
        ><a href="#">友情链接</a><a href="#">友情链接</a><a href="#">友情链接</a
        ><a href="#">友情链接</a><a href="#">友情链接</a><a href="#">友情链接</a
        ><a href="#">友情链接</a><a href="#">友情链接</a>
      </p>
    </div> -->

    <!--悬浮窗 -->
    <div class="xfk pc">
      <!--      <div class="xfka">-->
      <!--        <a @click="weServicer">在线客服</a>-->
      <!--      </div>-->
      <!--      <div class="xfkb">-->
      <!--        <a @click="Consultant1"></a>-->
      <!--      </div>-->
      <div class="xfkc">
        <a>公众号二维码</a>
        <img src="@/view/images/ewm1.png" />
      </div>
      <div class="yb_top" @click="yb_top">
        <a href="#"></a>
      </div>
    </div>

    <!--    &lt;!&ndash; 客服弹出窗 &ndash;&gt;-->
    <!--    <div class="popup" v-show="showServicer">-->
    <!--      <iframe-->
    <!--        src="https://cschat-ccs.aliyun.com/index.htm?tntInstId=_2L5GzlY&scene=SCE00010164"-->
    <!--        class="webService"-->
    <!--      ></iframe>-->
    <!--    </div>-->

    <!--    &lt;!&ndash; 弹出窗 &ndash;&gt;-->
    <!--    <div class="consultant" v-if="showConsultant">-->
    <!--      <div class="consultantHead">-->
    <!--        <div class="consultantInfo">-->
    <!--          联系信息-->
    <!--          <i-->
    <!--            class="el-icon-close"-->
    <!--            style="float: right;font-size: 20px;cursor: pointer;margin:10px;"-->
    <!--            @click="Consultant1"-->
    <!--          ></i>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <el-form-->
    <!--        :label-position="labelPosition"-->
    <!--        label-width="80px"-->
    <!--        :model="consultant"-->
    <!--        style="padding: 0px 20px;"-->
    <!--        :rules="rules"-->
    <!--        ref="consultant2"-->
    <!--      >-->
    <!--        <el-form-item label="姓名:" prop="name" style="padding:0px">-->
    <!--          <el-input-->
    <!--            v-model.trim="consultant.name"-->
    <!--            size="mini"-->
    <!--            style="padding: 0px 20px;"-->
    <!--            placeholder="请输入姓名"-->
    <!--          ></el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="联系电话:" prop="phone">-->
    <!--          <el-input-->
    <!--            v-model.trim="consultant.phone"-->
    <!--            size="mini"-->
    <!--            style="padding: 0px 20px;"-->
    <!--            placeholder="请输入11位手机号"-->
    <!--          ></el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="公司名称:" prop="company">-->
    <!--          <el-input-->
    <!--            v-model.trim="consultant.company"-->
    <!--            size="mini"-->
    <!--            style="padding: 0px 20px;"-->
    <!--            placeholder="请输入公司名称"-->
    <!--          ></el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="咨询内容:" prop="content">-->
    <!--          <el-input-->
    <!--            type="textarea"-->
    <!--            placeholder="在此输入咨询内容，我们会尽快与你联系~"-->
    <!--            v-model.trim="consultant.content"-->
    <!--          >-->
    <!--          </el-input>-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->
    <!--      <button class="submit" @click="submit">提交</button>-->
    <!--    </div>-->
  </div>
</template>

<script>
import $ from 'jquery'; // 在需要使用的页面中
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import cookies from '@/utils/cookie';
import API from '@/api';
import HeaderNav from '@/components/HeaderNav.vue';

export default {
  name: 'index',
  components: {
    HeaderNav,
  },
  data() {
    let checkedPhone = (rule, value, callback) => {
      const reg = /^1[3|4|5|7|8][0-9]{9}$/;
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      setTimeout(() => {
        if (!Number(value)) {
          callback(new Error('请输入数字值'));
        } else if (!reg.test(value)) {
            callback(new Error("请输入正确的手机号"));
          } else {
            callback();
          }
      }, 1000);
    };
    return {
      VUE_APP_LOGIN: process.env.VUE_APP_LOGIN,
      VUE_APP_USERCONSOLE: process.env.VUE_APP_USERCONSOLE,
      VUE_APP_HOME: process.env.VUE_APP_HOME,
      navaa: 0,
      logintype: 0,
      huakuai: 0,
      showchidenum: 0,
      loginshowtype: 0,
      showServicer: false,
      showConsultant: false,
      labelPosition: 'top',
      consultant: {
        name: '',
        phone: 0,
        company: '',
        content: ''
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { validator: checkedPhone, trigger: 'blur' },
          { required: true, trigger: 'blur' },
        ],
        company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '在此输入咨询内容', trigger: 'blur' },
        ],
      },
      userInfo: ''
    };
  },
  computed: {
    DataYears() {
      const date = new Date();
      const years = date.getFullYear();
      return years;
    },
  },
  created() {
    // if (cookies.get("token")) {
    //   this.getInfo();
    // }
    this.init();
    this.login();
  },
  methods: {
    // 退出登录
    exit() {
      this.$confirm('确定要退出登录吗?', '提示', {
        closeOnClickModal: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          cookies.remove('token');
          this.login();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    // 获取用户信息
    getInfo() {
      let token = cookies.get('token');
      let url = `${process.env.API_HOST  }/psl/user/info/get`;
      return new Promise((resolve, reject) => {
        API.information()
          .then((res) => {
            this.userInfo = res.message.data;
            cookies.set('userInfo', this.userInfo.power);
            resolve(); // 成功时resolve
          })
          .catch((err) => {
            console.error('获取用户信息失败:', err);
            reject(err); // 失败时reject
          });
      });
      // API.information()
      //   .then((res) => {
      //     this.userInfo = res.message.data;
      //     cookies.set('userInfo', this.userInfo.power);
      //   })
      //   .catch((mgs) => {
      //     console.log(mgs);
      //   });
    },
    login() {
      if (cookies.get('token')) {
        this.logintype = 1;
        this.getInfo();
      } else {
        this.logintype = 0;
      }
    },
    // 控制台
    async ToUserConsole() {
      console.log(this.userInfo.teamId);
      console.log(this.userInfo.roleId);

      if (cookies.get('token')) {
        try {
          // 等待getInfo完成
          await this.getInfo();
          // 确保userInfo已更新
          if (this.userInfo.teamId) {
            if (this.userInfo.roleId === '5a729bb3-f6c7-499b-b3c2-0193a99addda' || this.userInfo.roleId === '3644fc5d-ef69-4a30-8dad-6407b3120eed' || this.userInfo.roleId === '0ea0531a-94c9-4b57-90cb-7315b8c2b961') {
              window.open(`${this.VUE_APP_USERCONSOLE}PrintSteward/firstHome`, '_self');
            } else {
              window.open(`${this.VUE_APP_USERCONSOLE}PrintSteward/PrintHome`, '_self');
            }
          } else {
            window.open(`${this.VUE_APP_USERCONSOLE}Course`, '_blank');
          }
        } catch (error) {
          console.error('获取用户信息失败:', error);
          // 处理错误情况
        }
      } else {
        window.open(`${this.VUE_APP_LOGIN}login/:SUP/`, '_blank');
      }
    },
    // 咨询弹出窗
    Consultant1() {
      this.reset();
      this.showConsultant = !this.showConsultant;
      if (this.showServicer) {
        this.showServicer = false;
      }
    },
    // 重置表单
    reset() {
      this.consultant = {
        name: '',
        phone: '',
        company: '',
        content: ''
      };
    },
    // 提交留言
    submit() {
      this.$refs.consultant2.validate((valid) => {
        if (valid) {
          let url = `${process.env.API_HOST  }/portal/add`;
          this.$axios({
            method: 'post',
            url,
            data: this.consultant,
            contentType: 'application/json'
          })
            .then((res) => {
              if (res.data.code === '200') {
                this.reset();
                this.$message({
                  showClose: true,
                  message: '提交成功',
                  type: 'success',
                  duration: 2000,
                });
              } else {
                this.$message({
                  showClose: true,
                  message: '网络繁忙，稍后再试',
                  type: 'error',
                  duration: 2000,
                });
              }
            })
            .catch((mgs) => {
              this.$message({
                showClose: true,
                message: '网络繁忙，稍后再试',
                type: 'error',
                duration: 2000,
              });
            });
        }
      });
    },
    // 云服务弹窗
    weServicer() {
      this.showServicer = !this.showServicer;
      if (this.showConsultant) {
        this.showConsultant = false;
      }
    },
    init() {
      let navaa1 = this.$route.query.navaa;
      if (navaa1 != undefined) {
        this.navaa = navaa1;
      } else {
        this.navaa = 0;
      }
    },
    yb_top() {
      $('html,body').animate(
        {
          scrollTop: '0px'
        },
        300,
      );
    },
    showchide(id) {
      let _this = this;
      _this.showchidenum = id;
    },
    loginshow(id) {
      let _this = this;
      _this.loginshowtype = id;
    },
    navaabtn(id) {
      this.navaa = id;
    },
    hkbtn() {
      let _this = this;
      let huakuais = _this.huakuai;
      if (huakuais == 0) {
        _this.huakuai = 1;
      } else {
        _this.huakuai = 0;
      }
    },
    guanbi() {
      let _this = this;
      _this.huakuai = 0;
    },
    arrowClick(val) {
      if (val === 'right') {
        this.$refs.cardShow.next();
      } else {
        this.$refs.cardShow.prev();
      }
    },
    // login() {
    //   this.$router.push({ path: "/login" });
    // },
    // register() {
    //   this.$router.push({ path: "/register" });
    // }
  },
  mounted() {
    new Swiper('.swiper-container', {
      loop: true,
      slidesPerView: 1.7,
      centeredSlides: true,
    });
    // if (sessionStorage.getItem('needRefresh')) {
    //   sessionStorage.removeItem('needRefresh');
    //   setTimeout(() => location.reload(), 100); // 小延迟确保稳定
    // }
  },
};
</script>

<style scoped>
.submit {
  width: 100%;
  height: 30px;
  background: #f6b415;
  color: #fff;
  border: transparent;
  cursor: pointer;
}
.consultant {
  width: 400px;
  /* height: 500px; */
  position: fixed;
  top: 150px;
  right: 120px;
  z-index: 999;
  background: #fff;
}
.consultantHead {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  background: #f6b415;
}
.consultantInfo {
  margin-left: 15px;
}
.popup {
  width: 650px;
  height: 610px;
  position: fixed;
  top: 100px;
  right: 70px;
  z-index: 9999;
}
.webService {
  height: 620px;
  width: 600px;
  border: 0px;
}
.showtabdiv {
  opacity: 1 !important;
}

.huakuaileft {
  right: 0%;
}

.cardShow {
  width: 100%;
  position: relative;
}

.sjbannerbox {
  height: 200px;
  width: 100%;
}

.mobban {
  margin-top: 70px;
}

.bannericon {
  width: 100%;
  /*height: 625px;*/
}

.bannerbtn {
  width: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99;
}

.pc .bannericon {
  width: 1600px;
}

.mob,
.mob .alc {
  width: 90%;
}
</style>
<style>
.bannerboxli {
  width: 100%;
  overflow: hidden;
}

.cardShow .el-carousel__indicators--outside {
  width: 100% !important;
  position: absolute !important;
  bottom: 20% !important;
  left: 0 !important;
  z-index: 99 !important;
}

.cardShow .el-carousel__button {
  cursor: pointer;
  width: 7px;
  height: 7px;
  margin: 0 2.5px;
  float: left;
  position: relative;
  transition: all ease 0 0.35s;
  background-color: #fff;
  border-radius: 50%;
  opacity: 1;
  transition: all ease 0.35s;
}

.cardShow .el-carousel__indicator.is-active button {
  background-color: #f6b415;
  width: 30px;
  border-radius: 20px;
}

.mobban .el-carousel__indicators--outside {
  bottom: 0% !important;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue